import React from 'react';
import { Icon } from './Icon.js';
export const IconBarsFilter = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M7 12L12 12L17 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 5L21 5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13 19L11 19", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBarsFilter.js.map